import React, { useState, useRef, useContext } from 'react';
import { Notification } from '../../components/Notification/Notification.es.js';
import { StyledNotification } from '../../components/Notification/styled.es.js';
import styled from 'styled-components';
import { zIndex, spacing } from '../../utils/theme.es.js';
import '../../utils/assertions.es.js';
import '../../utils/responsive.es.js';
import '../../utils/scrollIntoView.es.js';
import '../../utils/useEnhancedEffect.es.js';
import 'react-is';
import { Portal } from '../../primitives/Portal/Portal.es.js';

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const BASE_NOTIFICATION_TIMEOUT = 3e3;
const NotificationContext = React.createContext({
  addNotification: () => void 0
});
const NotificationWrapper = styled.div`
    align-items: center;
    display: flex;
    flex-direction: column-reverse;
    pointer-events: none;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    z-index: ${zIndex("alert")};

    ${StyledNotification} {
        pointer-events: all;
        margin-top: ${spacing("sm")};
    }
`;
const NotificationProvider = ({
  baseNotificationTimeout = BASE_NOTIFICATION_TIMEOUT,
  notificationsLimit,
  children
}) => {
  const [notificationsMap, setNotifications] = useState(/* @__PURE__ */ new Map());
  const notificationCounter = useRef(0);
  const incrementCounter = () => {
    notificationCounter.current += 1;
  };
  const decrementCounter = () => {
    notificationCounter.current -= 1;
  };
  const closeNotification = (key, shouldNotDecrementCounter = false) => {
    const notification = notificationsMap.get(key);
    notification && notification.onClose && notification.onClose();
    notificationsMap.delete(key);
    !shouldNotDecrementCounter && decrementCounter();
    setNotifications(new Map(notificationsMap));
  };
  const addNotification = (notification) => {
    const isReachedNotificationLimit = notificationsLimit && notificationsMap.size === notificationsLimit;
    incrementCounter();
    const { current } = notificationCounter;
    const timeout = notification.timeout || baseNotificationTimeout;
    notificationsMap.set(current, __spreadProps(__spreadValues({}, notification), {
      timeout
    }));
    if (isReachedNotificationLimit) {
      const firstKeyValueOfTheMap = Array.from(notificationsMap.keys())[0];
      closeNotification(firstKeyValueOfTheMap, true);
    }
    setNotifications(new Map(notificationsMap));
  };
  return /* @__PURE__ */ React.createElement(NotificationContext.Provider, {
    value: { addNotification }
  }, /* @__PURE__ */ React.createElement(Portal, {
    zIndex: 2e3
  }, /* @__PURE__ */ React.createElement(NotificationWrapper, null, [...notificationsMap].map((_a) => {
    var [key, _b] = _a, _c = _b, { isPersistent, content, onClose } = _c, rest = __objRest(_c, ["isPersistent", "content", "onClose"]);
    return /* @__PURE__ */ React.createElement(Notification, __spreadValues({
      key,
      kind: isPersistent ? "persistent" : "temporary",
      onClose: () => {
        closeNotification(key);
        onClose == null ? void 0 : onClose();
      }
    }, rest), content);
  }))), children);
};
const useNotification = () => {
  const notificationContext = useContext(NotificationContext);
  const notify = notificationContext.addNotification;
  return { notify };
};

export { BASE_NOTIFICATION_TIMEOUT, NotificationContext, NotificationProvider, NotificationWrapper, useNotification };
//# sourceMappingURL=useNotification.es.js.map
